import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './resources/en';
import tr from './resources/tr';
import {
  DEFAULT_LANGUAGE,
  normalizeLanguage,
  readStoredLanguage,
  SUPPORTED_LANGUAGES,
  writeStoredLanguage,
} from './constants';

const resources = {
  en: { translation: en },
  tr: { translation: tr },
} as const;

const initialLanguage = (() => {
  const stored = readStoredLanguage();
  if (stored) return stored;
  try {
    return normalizeLanguage(navigator.language);
  } catch {
    return DEFAULT_LANGUAGE;
  }
})();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    interpolation: {
      escapeValue: false, // React already escapes
    },
  })
  .catch(() => {
    // no-op: i18n still usable with fallback
  });

i18n.on('languageChanged', (lng: string) => {
  writeStoredLanguage(normalizeLanguage(lng));
});

export default i18n;

